import React from "react";
import { useNavigate } from "react-router-dom";

function VisitDetails() {
  const navigate = useNavigate();

  return (
    <div className="details-container" style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8fafc',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '10px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e5e7eb'
      }}>
        {/* Back Button */}
        <div style={{ padding: '20px' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              backgroundColor: '#f9fafb',
              color: '#4b5563',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.backgroundColor = '#f3f4f6'}
            onMouseOut={(e) => e.target.backgroundColor = '#f9fafb'}
          >
            <i className="fas fa-arrow-left"></i>
            Back to QA Management
          </button>
        </div>

        {/* Header */}
        <div style={{
          backgroundColor: '#3b82f6',
          padding: '32px 20px',
          color: 'white'
        }}>
          <h1 style={{ margin: '0', fontSize: '24px', fontWeight: '600' }}>
            QA Visit Details
          </h1>
          <p style={{ margin: '8px 0 0 0', opacity: '0.9', fontSize: '14px' }}>
            Detailed inspection report and metrics
          </p>
        </div>

        {/* Content Placeholder */}
        <div style={{ 
          padding: '40px 20px',
          textAlign: 'center',
          backgroundColor: 'white'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#f3f4f6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            color: '#9ca3af',
            fontSize: '32px'
          }}>
            <i className="fas fa-microscope"></i>
          </div>
          <h2 style={{ 
            margin: '0 0 12px 0',
            fontSize: '20px',
            fontWeight: '600',
            color: '#374151'
          }}>
            Report Content Coming Soon
          </h2>
          <p style={{ 
            margin: '0',
            color: '#6b7280',
            maxWidth: '500px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            This component will display detailed quality assurance metrics, photos, 
            and feedback for the selected visit.
          </p>
          
          <div style={{ 
            marginTop: '32px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '16px',
            maxWidth: '800px',
            margin: '32px auto 0'
          }}>
            <div style={{ 
              padding: '20px',
              border: '2px dashed #e5e7eb',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '13px',
                color: '#6b7280',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: '8px',
                fontWeight: '600'
              }}>
                Operational Hygiene
              </div>
              <div style={{ 
                fontSize: '20px',
                fontWeight: '700',
                color: '#9ca3af'
              }}>
                TBD
              </div>
            </div>
            
            <div style={{ 
              padding: '20px',
              border: '2px dashed #e5e7eb',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '13px',
                color: '#6b7280',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: '8px',
                fontWeight: '600'
              }}>
                Teacher Presence
              </div>
              <div style={{ 
                fontSize: '20px',
                fontWeight: '700',
                color: '#9ca3af'
              }}>
                TBD
              </div>
            </div>
            
            <div style={{ 
              padding: '20px',
              border: '2px dashed #e5e7eb',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ 
                fontSize: '13px',
                color: '#6b7280',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: '8px',
                fontWeight: '600'
              }}>
                Compliance Score
              </div>
              <div style={{ 
                fontSize: '20px',
                fontWeight: '700',
                color: '#9ca3af'
              }}>
                TBD
              </div>
            </div>
          </div>
        </div>

        {/* Footer Info */}
        <div style={{
          padding: '16px 20px',
          backgroundColor: '#f9fafb',
          borderTop: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          color: '#6b7280',
          fontSize: '12px'
        }}>
          <span>Module: QA Management</span>
          <span>Generated locally for preview</span>
        </div>
      </div>
    </div>
  );
}

export default VisitDetails;